// extracted by mini-css-extract-plugin
export default {"nameContainer":"styles-module__nameContainer__src-labstep-web-components-File-Table-_MXs0u"};